<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="450">
      <v-card class="pa-6 card">
        <v-card-title class="pa-0 pb-7">
          <v-row no-gutters>
            <v-col cols="10">
              <h3 class="card__title">Оплата</h3>
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
              <v-btn icon @click="closeHandler">
                <v-icon color="red" large>close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pl-0 pr-2 pb-0">
          <v-col class="pa-0">
            <span class="card__info">{{ item.organizationInn }}</span>
            <span class="card__info pb-4">{{ item.organizationName }}</span>
            <span class="card__info">{{ item.personalInn }}</span>
            <span class="card__info pb-8">{{ item.fullName }}</span>
          </v-col>
          <v-row class="pb-2">
            <v-col cols="6">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFrom"
                    prepend-icon="event"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" @input="menu1 = false" locale="Ru-ru" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateTo"
                    placeholder="Укажите дату"
                    prepend-icon="event"
                    readonly
                    outlined
                    dense
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateTo" @input="menu2 = false" locale="Ru-ru" no-title></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn
              dark
              large
              class="text-capitalize"
              width="205"
              rounded
              color="#007AFF"
              @click="addPaymentHandler"
              :loading="loading"
              >Оплатить</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from 'moment'
export default {
  name: 'PickDates',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    item: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data: () => ({
    menu1: false,
    menu2: false,
    dateFrom: null,
    dateTo: null,
    loading: false
  }),
  watch: {
    item: {
      deep: true,
      handler(value) {
        if (value) {
          this.dateFrom = moment.unix(value.issuedAt).format('YYYY-MM-DD')
          this.dateTo = moment.unix(value.validUntil).format('YYYY-MM-DD')
        } else this.dateFrom = null
      }
    }
  },
  methods: {
    closeHandler() {
      this.$emit('close-pick-dates-modal', false)
      this.dateFrom = this.dateTo = null
    },
    async addPaymentHandler() {
      this.loading = true
      if (this.dateFrom && this.dateTo) {
        const payload = {
          inn: this.item.personalInn,
          organizationInn: this.item.organizationInn,
          paidFrom: this.dateFrom,
          paidTo: this.dateTo,
          paymentSum: 0,
          comment: '',
          haveAccess: true,
          serviceType: 'PkiStandard',
          isDebt: true,
          debtCompanyId: 0
        }

        await this.$store.dispatch('ADD_PAYMENT', payload)
        this.loading = false
        this.closeHandler()
      } else {
        await this.$store.dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: 'Поля с датами обязательны к заполнению'
        })
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  &__title {
    font-weight: 600;
    font-size: 32px;
    color: #000;
    padding-right: 90px;
  }
  &__info {
    font-weight: 400;
    font-size: 16px;
    color: #000;
    display: block;
  }
}
</style>
